export const homeServices = [
  {
    id: 1,
    title: 'Pré-Wedding',
    categorySlug: 'pre-wedding',
    description: 'Ensaios românticos que contam a história do casal antes do grande dia.',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/b2ef027698621a197bd775e73d4a1fe7.jpeg',
  },
  {
    id: 2,
    title: 'Casamentos',
    categorySlug: 'casamentos',
    description: 'Capturando cada emoção do seu dia mais especial. Do sim ao último brinde.',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/bd5d42fd63c0343c9f77f48722586092.jpeg',
  },
  {
    id: 3,
    title: 'Sessão Família',
    categorySlug: 'sessao-familia',
    description: 'A nossa melhor herança são as memórias que criamos juntos.',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/563cb60f567b9833c9cbff3981be6ed2.jpeg',
  },
  {
    id: 4,
    title: 'Celebração',
    categorySlug: 'celebracao',
    description: 'Aniversários, marcos e celebrações... O registro afetivo dos dias mais felizes da sua vida.',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/0fefe49df78d98c6ea7e09eb2cc0001c.jpeg',
  },
];

export const portfolioPreviewImages = [
  {
    id: 1,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/0dec238de7d5fe8f14936e40452e79c1.jpeg',
    alt: 'Noiva se preparando',
    category: 'Casamentos',
  },
  {
    id: 2,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/c518aad8a7a36dc8f90eec59138d7b83.jpeg',
    alt: 'Ensaio pré-wedding',
    category: 'Pré-Wedding',
  },
  {
    id: 3,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/68c3cbd9ecdc4d5edfb5413f51ced623.jpeg',
    alt: 'Cerimônia ao ar livre',
    category: 'Casamentos',
  },
  {
    id: 4,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/91f097dd19a0cfabdf20ce4586f555f7.jpeg',
    alt: 'Batizado',
    category: 'Sessão Família',
  },
  {
    id: 5,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/dc3ad3e14674b83b587c9f0d8d1eff79.jpeg',
    alt: 'Ensaio pré-wedding no jardim',
    category: 'Pré-Wedding',
  },
  {
    id: 6,
    src: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/38338eac109b9dcdef050a97d67ba2ee.jpeg',
    alt: 'Sessão família no parque',
    category: 'Sessão Família',
  },
];

export const testimonialsData = [
  {
    id: 1,
    quote: 'Oii Jee! Queremos te agradecer pelo trabalho incrível em nosso casamento. Amamos muito o resultado, as fotos ficaram lindas e conseguiram transmitir exatamente o que sentimos naquele dia. Dá pra ver o carinho e o talento indiscutível que você colocou em tudo. A foto com meus avós é a coisa mais preciosa que eu poderia ter guardado.',
    author: 'Grazi & Lucas',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/89be2840fd0c82d2f9e6fb1fefef4475.jpeg',
  },
  {
    id: 2,
    quote: 'Procurávamos uma fotógrafa que conseguisse expressar, através das fotos, todos os sentimentos que vivemos naquele momento tão especial e passageiro. Por isso, escolhemos a dedo a melhor profissional, não só pela qualidade impecável das fotos, mas pela sensibilidade de nos fotografar com alma. Ficamos muito felizes e à vontade durante o ensaio, e o resultado ficou maravilhoso! Não nos consideramos tão fotogênicos, mas não teve uma foto sequer de que não gostamos.',
    author: 'Ketlin & Luan',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/89be2840fd0c82d2f9e6fb1fefef4475.jpeg',
  },
  {
    id: 3,
    quote: 'Desde o início, sabíamos que queríamos algo elegante, e por isso escolhemos o Museu do Ipiranga como cenário desse momento tão especial. Criamos muitas expectativas para esse dia, e a Jéssica conseguiu superar cada uma delas com sensibilidade e cuidado.\n\nAs fotos ficaram exatamente como sonhamos: leves, sofisticadas e cheias de verdade. A sessão aconteceu de forma tão natural que, em muitos momentos, esquecíamos que estávamos sendo fotografados. Tudo fluiu com leveza, permitindo que fôssemos simplesmente nós mesmos, e isso tornou a experiência ainda mais especial.\n\nHoje, ao olharmos cada foto, sentimos saudade desse dia tão único e inesquecível. Sério, sinto saudades!',
    author: 'Paloma & Jhonatas',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/c9d6bfd759a2d749948d3c3f3b2586a6.jpeg',
  },
  {
    id: 4,
    quote: 'Queremos agradecer imensamente por todo o carinho, dedicação e profissionalismo em cada momento do nosso casamento. Desde o pré-wedding até a cerimônia e a cobertura da festa, você conseguiu registrar tudo de uma forma leve, sensível e simplesmente maravilhosa.\n\nCada foto transmite exatamente o que sentimos naquele dia tão especial, e isso é um dom. Obrigada por eternizar memórias tão importantes para nós com tanta beleza e cuidado. Foi um privilégio ter você fazendo parte desse momento único da nossa história.\n\nSeu trabalho é impecável e com certeza recomendamos de olhos fechados!',
    author: 'Ester & Geovane',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/89be2840fd0c82d2f9e6fb1fefef4475.jpeg',
  },
  {
    id: 5,
    quote: 'Não tem nem palavras para descrever tamanha gratidão! Desde o momento que fechamos o pacote de fotos até o dia do casamento, foi tudo bem alinhado com nossas ideias, referências, tipo de edição... confiamos de olhos fechados e superou nossas expectativas.\n\nA Jéssica me acompanhou enquanto eu me arrumava e direcionou todas as poses com a maior naturalidade, me ajudando sempre e topando todas as nossas ideias criativas! As fotos ficaram lindas, com o tipo de edição que eu queria, foram entregues extremamente rápido, e eu tenho vontade de postar uma por dia, de tanta foto boa que tem!\n\nCom certeza é uma profissional que eu indico!',
    author: 'Luiza & Gabriel',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/89be2840fd0c82d2f9e6fb1fefef4475.jpeg',
  },
];

export const blogPreviewPosts = [
  {
    id: 1,
    title: 'Como escolher o fotógrafo perfeito para o seu casamento',
    excerpt: 'Dicas essenciais para encontrar o profissional que vai capturar seus momentos mais preciosos.',
    date: '15 Maio 2026',
    image: 'https://static.readdy.ai/image/a7593ab01aa731c0cb39690e041d41d7/380ff33595edfe26a1555b910654aa78.jpeg',
    category: 'Dicas',
  },
  {
    id: 2,
    title: 'Tendências de fotografia de casamento para 2026',
    excerpt: 'Descubra os estilos e técnicas que estão definindo a fotografia de casamento este ano.',
    date: '02 Maio 2026',
    image: 'https://readdy.ai/api/search-image?query=modern%20wedding%20photography%20flat%20lay%20with%20rings%20flowers%20invitation%20cards%20elegant%20styling%20on%20marble%20surface%20soft%20natural%20light%20editorial%20style%20warm%20tones&width=500&height=350&seq=31&orientation=landscape',
    category: 'Tendências',
  },
  {
    id: 3,
    title: 'O que levar para o seu ensaio pré-wedding',
    excerpt: 'Guia completo de preparação para tirar o máximo proveito do seu ensaio fotográfico.',
    date: '20 Abril 2026',
    image: 'https://readdy.ai/api/search-image?query=pre%20wedding%20photo%20shoot%20outfit%20ideas%20couple%20standing%20in%20nature%20elegant%20casual%20styling%20romantic%20atmosphere%20warm%20sunset%20light%20professional%20photography&width=500&height=350&seq=32&orientation=landscape',
    category: 'Dicas',
  },
];